import { makeStyles } from '@mui/styles';

export const useColumnFilterPopperStyles = makeStyles(theme => ({
  popup: {
    zIndex: 100,
  },
  filterInput: {
    width: '100%',
  },
  selectFormControl: {
    minWidth: '10em',
    width: '100%',
  },
  selectMenuControl: {
    marginTop: 50,
    height: 300,
    width: '100%',
    minWidth: 150,

    '& > .MuiPaper-root': {
      top: '0 !important',
      left: '1rem !important',
    },
  },
  conditionsFormControl: {
    marginLeft: theme.spacing(3),
  },
  multiselectContainer: {
    maxHeight: '300px',
    overflowY: 'auto',
    minWidth: '200px',
  },
}));
